import { map, cloneDeep } from 'lodash'
import  {
  ADD_CONTENT_FRAGMENT,
  ERROR_CONTENT_FRAGMENT
} from 'state/contentFragments/ContentFragmentActions';
import { stripNewLine } from 'utils/FormattingUtil';

export const contentFragmentReducer = (state = {}, action) => {
  const { type } = action;

  if(type === ADD_CONTENT_FRAGMENT) {
    const { fragment, step } = action;
    if(fragment) {
      let copyState = cloneDeep(state);
      copyState[step] = map(fragment, contentFragment => {
        const { elements: { question, answer } } = contentFragment;
        const transformedQuestion = stripNewLine(question.value);
        const transformedAnswer = stripNewLine(answer.value);
        return {
          question: { ...question, value: transformedQuestion },
          answer: { ...answer, value: transformedAnswer }
        }
      });
      return {
        ...copyState
      }
    }
    return state;
  }
  return state;
};

export const contentFragmentInErrorReducer = (state = false, action) => {
  const { type } = action;

  if(type === ERROR_CONTENT_FRAGMENT) {
    return true;
  }

  return state;
};